import React, { useCallback, useState } from "react";
import PDFViewer from "./PDFViewer";
import OfficeViewer from "./OfficeViewer";
import { Button } from "../index";
import { downloadFileWithoutInstance } from "../../common/services";
import { getFileExtension } from "../../utils/common";

export const FileViewer = ({ file, docId, fileType, pageNumber, sheet, row, onError, searchText }) => {
    // `file` is either a (presigned) URL or an S3 object with a `Key`.
    const normalizedFileType = fileType ? fileType.toLowerCase() : getFileExtension(typeof file === "string" ? file : file?.Key);

    const isPdf = normalizedFileType === "pdf" || normalizedFileType === "application/pdf";
    const isOffice = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"].includes(normalizedFileType);

    if (isPdf) {
        return (
            <div className="bimmatch-file-viewer-container">
                <PDFViewer 
                    file={file} 
                    docId={docId}
                    pageNumber={pageNumber} 
                    searchText={searchText}
                    onDocumentLoadError={onError}
                />
            </div>
        );
    }

    if (isOffice) {
        return (
            <div className="bimmatch-file-viewer-container">
                <OfficeViewer file={file} pageNumber={pageNumber} sheet={sheet} row={row} hideDownloadButton />
            </div>
        );
    }

    return (
        <div className="bimmatch-file-viewer-container">
            <p>Preview not available for this file type ({normalizedFileType}).</p>
            <DownloadButton file={file} />
        </div>
    );
};

const DownloadButton = ({ file }) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleDownload = useCallback(async () => {
        try {
            setIsLoading(true);
            await downloadFileWithoutInstance(file);
        } catch (error) {
            console.error("Error generating download URL", error);
        } finally {
            setIsLoading(false);
        }
    }, [file]);

    return (
        <Button onClick={handleDownload} loading={isLoading}>
            Download file
        </Button>
    );
};

export default FileViewer;
